import { alpha } from "@mui/material/styles";
const colors = {
    primary: {
        0: "#FFFFFF",
        50: "#E6F0FE",
        100: "#CEE3FF",
        200: "#B1D3FF",
        300: "#61A3FF",
        400: "#3080F0",
        500: "#0068F0",
        600: "#1661C5",
        700: "#074290",
        800: "#0B3166",
        900: "#1A243D"
    },
    secondary: {
        50: "#D5E3FE",
        100: "#B9CBEE",
        200: "#849AC6",
        300: "#6B82AD",
        400: "#556990",
        500: "#394A6B",
        600: "#28344B",
        700: "#1A2230",
        800: "#121721",
        900: "#0A0C12"
    },
    error: {
        0: "#FFFFFF",
        50: "#FFF3F3",
        100: "#FFC2C2",
        200: "#FF9B9B",
        300: "#FF7E7E",
        400: "#FF7474",
        500: "#FF6376",
        600: "#CE4455",
        700: "#79272D",
        800: "#4B0E11",
        900: "#1D0305"
    },
    pending: {
        0: "#FFFFFF",
        50: "#FEFAE6",
        100: "#FDF5CF",
        200: "#FBECA1",
        300: "#F7E27B",
        400: "#F3D960",
        500: "#EDD04F",
        600: "#D2B33B",
        700: "#AD7600",
        800: "#685919",
        900: "#322A07"
    },
    success: {
        0: "#FFFFFF",
        50: "#E9FEFA",
        100: "#D4FCF5",
        200: "#AEFAEA",
        300: "#91F8E1",
        400: "#7EF3D7",
        500: "#6BE5C3",
        600: "#61D3B2",
        700: "#4CAA8F",
        800: "#2C6959",
        900: "#11322A"
    },
    tertiary: {
        0: "#FFFFFF",
        50: "#F6F6F7",
        100: "#E7EAF3",
        200: "#D0D7E6",
        300: "#BBC4DA",
        400: "#A7B2CE",
        500: "#8492B5",
        600: "#68769C",
        700: "#3D4A6B",
        800: "#2C3752",
        900: "#040508"
    },
    warning: {
        10: "#DF5B00",
        40: "#FFA364",
        90: "#FEEDD8"
    }
};
const primary = {
    light: colors.primary[300],
    main: colors.primary[500],
    dark: colors.primary[700],
    container: colors.primary[100],
    hover: alpha(colors.primary[50], 0.12),
    focused: alpha(colors.primary[50], 0.16),
    pressed: alpha(colors.primary[50], 0.26),
    dragged: alpha(colors.primary[50], 0.08),
    selected: alpha(colors.primary[50], 0.24)
};
const secondary = {
    main: colors.secondary[600],
    container: colors.primary[100],
    hover: alpha(colors.primary[50], 0.12),
    focused: alpha(colors.primary[50], 0.16),
    pressed: alpha(colors.primary[50], 0.26),
    dragged: alpha(colors.primary[50], 0.08),
    selected: alpha(colors.primary[50], 0.24)
};
const error = {
    light: colors.error[300],
    main: colors.error[500],
    dark: colors.error[700]
};
const success = {
    main: colors.success[600],
    container: colors.success[100]
};
const warning = {
    main: colors.warning[40],
    container: colors.warning[90]
};
const background = {
    default: "#fff",
    paper: "#fff"
};
const light = {
    mode: "light",
    primary,
    secondary,
    error,
    success,
    background,
    action: {
        selected: "#E6F0FE"
    },
    warning,
    tertiary: secondary,
    quarternary: secondary,
    ghostGray: secondary,
    ghostPrimary: secondary,
    linkGray: secondary,
    linkPrimary: secondary,
    none: secondary,
    gray: secondary,
    neutral: secondary,
    destructive: secondary
};
export default light;

//# sourceMappingURL=index.js.map